// src/utils/storage.ts
import { Participant, Event } from '../data/eurovisionData';

export interface Submission {
  id: string;
  email: string;
  username: string;
  country: string; // Keep as string, we'll just pass an empty string
  ranking: (Participant | null)[];
  timestamp: number;
  event: Event;
}

const STORAGE_KEY = 'eurovision-rankings';

export const saveSubmission = (submission: Omit<Submission, 'id' | 'timestamp'>): Submission => {
  // Generate a unique ID and add timestamp
  const completeSubmission: Submission = {
    ...submission,
    id: Date.now().toString(36) + Math.random().toString(36).substring(2),
    timestamp: Date.now()
  };
  
  // Get existing submissions
  const existingData = localStorage.getItem(STORAGE_KEY);
  const submissions: Submission[] = existingData ? JSON.parse(existingData) : [];
  
  // Add new submission
  submissions.push(completeSubmission);
  
  // Save back to localStorage
  localStorage.setItem(STORAGE_KEY, JSON.stringify(submissions));
  
  return completeSubmission;
};

export const getSubmissions = (): Submission[] => {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : [];
};

export const getSubmissionById = (id: string): Submission | undefined => {
  const submissions = getSubmissions();
  return submissions.find(sub => sub.id === id);
};